import { Link } from 'react-router-dom';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { styled, Typography } from '@mui/material';

import { Icon, useSettings, Text, Utils } from 'app/main/components';

interface DetailsPageHeaderSystemInfoProps {
	module: string;
	model: any;
}

const StyledLink = styled(Link)(({ theme }) => ({
	'&:not([role=button]):not(.MuiButtonBase-root)': {
		color: 'inherit',
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'none'
		}
	}
}));

function UserText({ value, uid }: { value?: string; uid?: string }) {
	const to = `/users/details/${uid}`;

	return (
		<>
			<Text className="inline font-600 text-inherit" to={to}>
				{value}
			</Text>
			<StyledLink to={to}>
				<Icon className="mx-4 inline" icon="open-in-new" size={14} />
			</StyledLink>
		</>
	);
}

function Date({ value }: { value?: string | null }) {
	return (
		<FormattedDate
			value={Utils.parseDate(value)?.toDate()}
			year="numeric"
			month="long"
			day="numeric"
			hour="numeric"
			minute="numeric"
			second="numeric"
		/>
	);
}

export default function DetailsPageHeaderSystemInfo({ module, model }: DetailsPageHeaderSystemInfoProps) {
	const { settings, t } = useSettings(module);

	return (
		<>
			{/* USER CREATE */}
			<Typography className="p-2" component="div">
				<FormattedMessage
					id="systemInfo.created"
					defaultMessage={t('SYSTEMINFO_CREATED')}
					values={{
						datetime: <Date value={model[`${settings.modu_short}_d_created`]} />,
						user: (
							<UserText
								value={model.user_created_title}
								uid={model[`${settings.modu_short}_user_created_uid`]}
							/>
						)
					}}
				/>
			</Typography>
			{/* USER MODIFY */}
			<Typography className="p-2" component="div">
				<FormattedMessage
					id="systemInfo.modified"
					defaultMessage={t('SYSTEMINFO_MODIFIED')}
					values={{
						datetime: <Date value={model[`${settings.modu_short}_d_modified`]} />,
						user: (
							<UserText
								value={model.user_modified_title}
								uid={model[`${settings.modu_short}_user_modified_uid`]}
							/>
						)
					}}
				/>
			</Typography>
			{/* USER DELETE */}
			{model[`${settings.modu_short}_deleted`] && (
				<Typography className="p-2" component="div" color="warning.main">
					<Icon className="mr-4 inline" icon="delete-alert" size={18} />
					<div className="inline">
						<FormattedMessage
							id="systemInfo.deleted"
							defaultMessage={t('SYSTEMINFO_DELETED')}
							values={{
								datetime: <Date value={model[`${settings.modu_short}_d_deleted`]} />,
								user: (
									<UserText
										value={model.user_deleted_title}
										uid={model[`${settings.modu_short}_user_deleted_uid`]}
									/>
								)
							}}
						/>
					</div>
				</Typography>
			)}
		</>
	);
}
